<script setup lang="ts">
import type { ToggleCustomEvent } from '@ionic/core';
import type { IonToggle } from '#build/components';
import { useTemplateRef } from 'vue';

interface Props {
  label: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
}

const props = defineProps<Props>();
const emits = defineEmits<{ change: [boolean] }>();
const toggle = useTemplateRef('toggle');

async function handleChange(event: ToggleCustomEvent) {
  emits('change', event.detail.checked);
}
</script>

<template>
  <IonItem lines="full">
    <IonLabel>
      <IonToggle
        ref="toggle"
        :checked="checked"
        class="ion-text-wrap"
        :disabled="disabled"
        @ion-change="handleChange"
      >
        <IonLabel class="ion-text-wrap">
          {{ label }}
        </IonLabel>
      </IonToggle>
      <p
        class="ion-no-margin"
        @click="toggle?.$el.click"
      >
        {{ description }}
      </p>
    </IonLabel>
  </IonItem>
</template>

<style scoped>
</style>
